import { useState } from 'react';
import {DEFAULT_DAILY, GAME_MODES, STANDARD_CATEGORIES_BY_KEY} from "@/lib/constants";
import Correctness from "@/components/common/Correctness";
import ReviewButton from "@/components/common/buttons/ReviewButton";
import {STORAGE_KEY, dailyToPieMask, getUtmProductUrl, sendGtagEvent} from "@/lib/utils";
import SummaryHeader from '@/components/common/SummaryHeader';
import Pie from "@/components/common/pie/Pie";
import ShareButton from '../common/buttons/ShareButton';
import StatsButton from '../common/buttons/StatsButton';
import Panel from '../panels/Panel';
import Playlist from '../common/Playlist';
import DailyLifetimeModal from './DailyLifetimeModal';
import { DateTime, Settings } from 'luxon';

Settings.defaultZone = 'America/New_York'

const DailyChallengeSummary = ({ data=DEFAULT_DAILY, onShare, userState }) => {
    const [showPlaylist, setShowPlaylist] = useState(false)
    const [showLifetimeStats, setShowLifetimeStats] = useState(false)

	const pieMask = dailyToPieMask(data?.wedges)

    const togglePlaylist = () => {
		setShowPlaylist(!showPlaylist)
	}

    const toggleLifetimeStats = () => {
		setShowLifetimeStats(true)
	}

    const onCancel = () => {
		setShowLifetimeStats(false);
		return true;
	};

    return (<>        
        <Panel>
            <div className={'w-full flex flex-col rounded-lg md:p-2 p-2 pt-2'}>
                <SummaryHeader title={"Daily Challenge"} subtitle={new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })} />
                <div className={'flex flex-col gap-3 relative items-center mt-6'}>
                    <Pie width={80} height={80}
                            entertainment={pieMask & STANDARD_CATEGORIES_BY_KEY.entertainment.mask}
                            geography={pieMask & STANDARD_CATEGORIES_BY_KEY.geography.mask}
                            sports={pieMask & STANDARD_CATEGORIES_BY_KEY.sports.mask}
                            science={pieMask & STANDARD_CATEGORIES_BY_KEY.science.mask}
                            history={pieMask & STANDARD_CATEGORIES_BY_KEY.history.mask}
                            arts={pieMask & STANDARD_CATEGORIES_BY_KEY.arts.mask}
                            data-testid="review-questions"
                            className={'z-10'}
                        />
                    <Correctness numCorrect={data?.collectedToday} className="pt-0" />
                    <ReviewButton open={showPlaylist} onClick={togglePlaylist} />
                    { (showPlaylist) ?
				
                        <Playlist
                        title={'Daily Challenge'}
                        subtitle={`Summary - ${DateTime.fromISO(data.lastAction).toLocaleString()}`}
                        history={data.history}
                        onShare={onShare}
                        onBack={() =>setShowPlaylist(false)}
                        />: null
                    }
                    <ShareButton onClick={onShare}/>
                    <StatsButton onClick={toggleLifetimeStats} className={'flex xl:hidden'}/>
                </div>
            </div>
        </Panel>
        <DailyLifetimeModal className={showLifetimeStats ? 'flex' : 'hidden'} onCancel={onCancel} data={data} />
    </>)
}

export default DailyChallengeSummary;
